import android from '../../assets/android.png'
import ios from '../../assets/ios.png'
export default {
  name: 'ayuda-v-2',
  components: {},
  props: [],
  data () {
    return {
      android,
      ios
    }
  },
  computed: {},
  mounted () {},
  methods: {}
}
